export type EvidenceBadgeTier = 'exact' | 'nearby' | 'section' | 'unknown';

const labels: Record<Exclude<EvidenceBadgeTier, 'unknown'>, string> = {
  exact: '같은 자리',
  nearby: '근처',
  section: '같은 구역',
};

type EvidenceDistanceBadgeProps =
  | { tier: 'unknown'; count?: never }
  | { tier: Exclude<EvidenceBadgeTier, 'unknown'>; count: number };

export function EvidenceDistanceBadge({ tier, count }: EvidenceDistanceBadgeProps) {
  if (tier !== 'unknown' && count === 0) return null;
  const text = tier === 'unknown' ? '아직 앉아본 기록이 없어요' : `${labels[tier]} ${count}건`;
  return (
    <span className={`evidence-badge evidence-${tier}`}>
      <span className="evidence-mark" aria-hidden="true" />
      <span>{text}</span>
    </span>
  );
}
